module.exports = __webpack_public_path__ + "static/img/rm_brand_img_ousaisi_top.2d44f43.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rm_brand_img/rm_brand_img_ousaisi_top.png
// module id = Vwj2
// module chunks = 1